module.exports = __webpack_public_path__ + "img/img2.76a8c98f.png";